export default function ContactStrip() {
  return (
    <section className="bg-gold py-10 md:py-12">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-0 md:divide-x md:divide-white/20">
          {/* WhatsApp */}
          <a
            href="https://wa.me/18453701756"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="flex items-center justify-center gap-4 group cursor-pointer md:pr-10"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors duration-300">
              <i className="ri-whatsapp-line text-white text-2xl" />
            </div>
            <div>
              <p className="text-white/60 text-xs font-sans font-semibold tracking-widest uppercase">
                WhatsApp
              </p>
              <p className="text-white font-display font-bold text-xl">
                1-845-370-1756
              </p>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:Mswashington@thelittyagency"
            className="flex items-center justify-center gap-4 group cursor-pointer md:pl-10"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white/10 group-hover:bg-white/20 transition-colors duration-300">
              <i className="ri-mail-line text-white text-2xl" />
            </div>
            <div>
              <p className="text-white/60 text-xs font-sans font-semibold tracking-widest uppercase">
                Email
              </p>
              <p className="text-white font-display font-bold text-xl">
                Mswashington@thelittyagency
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
